import {fetchGet, fetchPatch, generateEndpoint} from "../utils/request";

export const getCases = async({ token }) => {
  const url = `${generateEndpoint('getCases')}`
  return fetchGet(url, token)
}

export const getCaseByIdWorker = async({ token, id }) => {
  const url = `${generateEndpoint('getCaseByIdWorker')}?id=${id}`
  return fetchGet(url, token)
}

export const updateSurveyByIdUser = async({ token, id, surveyResponses, feedbackDescription }) => {
  const url = `${generateEndpoint('updateSurveyByIdUser')}`
  return fetchPatch(url, token, { id, surveyResponses, feedbackDescription })
}

export const updateSurveyByIdWorker = async({ token, id, surveyResponses, feedbackDescription }) => {
  const url = `${generateEndpoint('updateSurveyByIdWorker')}`
  return fetchPatch(url, token, { id, surveyResponses, feedbackDescription })
}
